import { SubAccountSalesInterface } from '../types/sub-account-interface'

export const getSubAccountSalesStatistics = (
  account: { user: { id: number } },
  sales?: SubAccountSalesInterface[],
): SubAccountSalesInterface | null => {
  if (!sales) return null

  return sales.find(({ user }) => user.id === account.user.id) ?? null
}
